<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="baseView.mode"
    :tabs="tabs"
    :backButtonEnable="true"
    :selectedIndex="selectedIndex"
    :hot-key-grid-tab-index="1"
    :backButtonFunction="backButtonFunction"
    :formsConfig="formsConfig"
  >
    <template #headerContent>
      <!-- <GcHeaderContentStatic title="Create Stocktake" /> -->
      <GcHeaderContentDynamic
        title="Stocktake Count"
        :baseView="baseView"
        :primaryLabel="'Count for Stocktake # ' + model.StocktakeCode"
        :secondaryLabel="null"
        v-if="model.StocktakeCode"
      />
    </template>
    <div class="stocktake-count">
      <dx-data-grid
        :data-source="model.BranchCode ? dataSourceConfig : []"
        :columns="stockTakeCountColumns"
        :height="gridHeight"
        :column-chooser="{ enabled: false }"
        @toolbar-preparing="onToolbarPreparingPGCustomer($event)"
        ref="stocktake-count-grid"
        @initialized="stockTakeCountInitialized"
        @focused-cell-changed="focusedCellChanged"
        @key-down="keyDown"
        v-if="loadingCompleted"
      >
        <!-- @selection-changed="onSelectionChanged" -->

        <!-- <DxEditing :allow-updating="true" mode="cell" /> -->

        <template #branchTemplate="{ data }">
          <div class="custom-auto-complete">
            <span class="auto-complete-primary">{{
              data.BranchDescription
            }}</span>
            <span class="auto-complete-secondary">{{ data.BranchCode }}</span>
          </div>
        </template>

        <template #ProductCategory2Template="{ data }">
          <div class="custom-auto-complete">
            <span class="auto-complete-primary">{{ data.Description }}</span>
            <span class="auto-complete-secondary">{{ data.Code }}</span>
          </div>
        </template>

        <template #primaryImageTemplate="{ data }">
          <GcGridProductImage
            :ItemCode="data.data.ProductCode"
            :HasPrimaryImage="data.data.HasPrimaryImage"
            :Description="data.data.ProductDescription"
          />
        </template>

        <template #ref-no-cell-template="{ data }">
          <div class="gc-editor-cell">
            <DxTextBox
              :value="data.value"
              class="gc-border-bottom-dotted"
              :disabled="!data.data.editable"
              @value-changed="onValueChange($event, data, 'ReferenceNo')"
            />
          </div>
        </template>

        <template #bin-cell-template="{ data }">
          <div id="bin-root">
            <div v-if="data.data.editable">
              <DxSelectBox
                :data-source="getBinLocationDataSource()"
                keyExpr="BinLocationCode"
                displayExpr="BinLocationCode"
                :drop-down-options="{ width: 250 }"
                class="gc-dropdown-icon-button gc-border-bottom-dotted"
                styling-mode="text"
                :show-arrow-icon="false"
                :value="data.value"
                valueExpr="BinLocationCode"
                :disabled="!data.data.editable"
                :acceptCustomValue="false"
                item-template="bin-item-template"
                @value-changed="onValueChange($event, data, 'BinLocationCode')"
                :search-enabled="true"
                :searchExpr="['BinLocationCode', 'BinLocationLocation']"
              >
                <template #bin-item-template="{ data }">
                  <div class="custom-auto-complete">
                    <span class="auto-complete-primary">{{
                      data.BinLocationLocation
                    }}</span>
                    <span class="auto-complete-secondary">{{
                      data.BinLocationCode
                    }}</span>
                  </div>
                </template>
              </DxSelectBox>
            </div>
            <div v-if="!data.data.editable">
              <div class="gc-auto-cmp">{{ data.data.BinLocationCode }}</div>
            </div>
          </div>
        </template>

        <template #batch-no-cell-template="{ data }">
          <!-- <div > -->
          <div id="batch-root" v-if="data.data.IsBatchProduct != 'No'">
            <div v-if="data.data.editable">
              <DxSelectBox
                :data-source="getBatchNoDataSource(data.data.ProductCode)"
                keyExpr="BatchNo"
                displayExpr="BatchNo"
                :drop-down-options="{ width: 350 }"
                class="gc-dropdown-icon-button gc-border-bottom-dotted"
                styling-mode="text"
                :show-arrow-icon="false"
                :value="data.value"
                valueExpr="BatchNo"
                :disabled="!data.data.editable"
                :acceptCustomValue="true"
                @customItemCreating="
                  onCustomItemCreating($event, data, 'BatchNo')
                "
                @itemClick="clickOnBatchNo($event, data)"
                item-template="batch-no-item-template"
                :search-enabled="true"
                :searchExpr="['BatchNo', 'SupplierName']"
              >
                <template #batch-no-item-template="{ data }">
                  <div class="custom-auto-complete">
                    <span class="auto-complete-primary">{{
                      data.BatchNo
                    }}</span>
                    <span class="auto-complete-secondary">{{
                      data.SupplierCode
                    }}</span>
                    <span class="auto-complete-secondary">{{
                      data.SupplierName
                    }}</span>
                  </div>
                </template>
              </DxSelectBox>
            </div>
            <div v-if="!data.data.editable">
              <div class="gc-auto-cmp">{{ data.data.BatchNo }}</div>
            </div>
          </div>
          <!-- </div> -->
        </template>

        <template #supplier-cell-template="{ data }">
          <div id="supplier-root" v-if="data.data.IsBatchProduct != 'No'">
            <div v-if="data.data.editable && !data.data.batchSelected">
              <DxSelectBox
                :data-source="getSupplierDataSource(data.data.ProductCode)"
                keyExpr="SupplierCode"
                displayExpr="SupplierName"
                :drop-down-options="{ width: 300 }"
                class="gc-dropdown-icon-button gc-border-bottom-dotted"
                styling-mode="text"
                :show-arrow-icon="false"
                :value="data.value"
                valueExpr="SupplierCode"
                :disabled="data.data.batchSelected"
                :acceptCustomValue="false"
                item-template="supplier-item-template"
                @itemClick="onClickSupCode($event, data)"
                :search-enabled="true"
                @value-changed="onValueChange($event, data, 'SupplierCode')"
                :searchExpr="['SupplierCode', 'SupplierName']"
              >
                <template #supplier-item-template="{ data }">
                  <div class="custom-auto-complete">
                    <span class="auto-complete-primary">{{
                      data.SupplierName
                    }}</span>
                    <span class="auto-complete-secondary">{{
                      data.SupplierCode
                    }}</span>
                  </div>
                </template>
              </DxSelectBox>
            </div>
            <div v-if="!data.data.editable || data.data.batchSelected">
              <div class="gc-auto-cmp">{{ data.data.SupplierName }}</div>
            </div>
          </div>
        </template>
        <!-- @value-changed="onValueChange($event, data, 'SupplierCode')" -->

        <template #use-by-date-cell-template="{ data }">
          <div v-if="data.data.IsBatchProduct != 'No'">
            <DxDateBox
              :value="data.value"
              @value-changed="onValueChange($event, data, 'UseByDate')"
              display-format="dd MMM yyyy"
              class="gc-border-bottom-dotted"
              :disabled="data.data.batchSelected"
            />
          </div>
        </template>

        <template #count-cell-template="{ data }">
          <div class="gc-editor-cell">
            <DxNumberBox
              :value="data.value"
              :format="data.column.format"
              class="gc-border-bottom-dotted"
              :max="999999999.99"
              :disabled="
                !data.data.editable
                  ? true
                  : data.data.IsBatchProduct === 'No'
                  ? false
                  : data.data.SupplierCode
                  ? false
                  : true
              "
              @value-changed="onValueChange($event, data, 'Count')"
            />
          </div>
        </template>

        <template #count-to-date-cell-template="{ data }">
          <div class="gc-editor-cell">
            <DxNumberBox
              :value="data.value"
              :format="data.column.format"
              class="gc-border-bottom-dotted"
              :min="0.0"
              :max="999999999.99"
              :disabled="true"
            />
          </div>
        </template>

        <template #copy-cell-template="{ data }">
          <DxButton icon="plus" @click="onAddClickHandler(data)" />
        </template>
      </dx-data-grid>
    </div>
  </gc-main-layout>
</template>

<script>
import BaseViewMixin from "../../v1/_mixins/base.view";
import { StocktakeCountService } from "../../_services/api/inventory/stocktake-count.service";
import { BranchService } from "../../_services/api/sales/branch.service";
import { ProductCategory1Service } from "../../_services/api/settings/products/product-category-1.service";

let detailsGridInstance = null;
let filterFunction = (x) => {
  return (
    x.ProductCode.toLowerCase().indexOf(
      detailsGridInstance._options._optionManager._options.searchPanel.text.toLowerCase()
    ) !== -1 ||
    x.ProductDescription.toLowerCase().indexOf(
      detailsGridInstance._options._optionManager._options.searchPanel.text.toLowerCase()
    ) !== -1
  );
};
var ds = StocktakeCountService.dataSourceConfig("api/StocktakeCount", {
  key: "RecordId",
  // sort: [{ selector: "ProductCode", asc: true }],
  postProcess: (data) => {
    data.forEach((row) => {
      if (row.ReferenceNo) {
        row.editable = false;
        row.batchSelected = true;
      } else {
        row.editable = true;
        if (row.BatchNo) {
          row.batchSelected = true;
        } else {
          row.batchSelected = false;
        }
      }
    });

    copyItemsData.forEach((element) => {
      let x = data.filter((i) => {
        return i.CopyCode == element.CopyCode;
      });

      if (x.length == 0 && element.BranchCode == globalBranchCode) {
        data.splice(element.index + 1, 0, element);
      }
    });

    if (detailsGridInstance) data = data.filter(filterFunction);

    return data;
  },
});

var copyItemsData = [];
var globalBranchCode = null;

export default {
  props: {},
  mixins: [BaseViewMixin],
  data() {
    return {
      dataSourceConfig: [],
      model: {
        StocktakeCode: null,
        BranchCode: null,
        ProductCategory2Code: null,
      },
      currentRowIndex: null,
    };
  },
  components: {},
  created() {
    this.selectedIndex = 1;
    this.model.StocktakeCode = this.baseView.id;
    // await this.$store.dispatch("screenFactors/getFactors", [65]);

    // let factor65 = this.getFactorByCode(65).Factorc;
    // if (factor65) {
    //   this.model.BranchCode = globalBranchCode = factor65;
    //   this.refreshView();
    // }
    this.Initialized();
  },
  beforeDestroy() {
    copyItemsData.splice(0, copyItemsData.length);
  },
  computed: {
    stockTakeCountColumns() {
      return this.parseGridColumns("transaction-editable", [
        {
          gcLabel: "Item",
          gcType: "String",
          gcSubType: "PrimaryRecord",
          dataField: "ProductDescription",
          cellTemplate: "primaryImageTemplate",
        },
        {
          gcLabel: "Item",
          dataField: "ProductCode",
          width: 120,
          gcType: "String",
          gcSubType: "HiddenCode",
        },
        {
          gcLabel: "Description",
          dataField: "ProductDescription",
          minWidth: this.gridColumnMinWidth(220),
          gcType: "String",
          gcSubType: "HiddenDescription",
        },

        {
          gcLabel: "UM",
          dataField: "UnitOfMeasureCode",
          gcType: "String",
          width: 100,
        },

        {
          gcLabel: "Ref No",
          dataField: "ReferenceNo",
          gcType: "String",
          width: 100,
          cellTemplate: "ref-no-cell-template",
          allowFiltering: false,
          allowSorting: false,
          sortOrder: "asc",
          sortIndex: "3",
        },

        {
          gcLabel: "Bin",
          dataField: "BinLocationCode",
          gcType: "String",
          width: 100,
          cellTemplate: "bin-cell-template",
          allowFiltering: false,
          allowSorting: false,
          allowEditing: true,
        },

        {
          gcLabel: "Batch Date Created",
          dataField: "BatchDateCreated",
          gcType: "Date",

          sortOrder: "asc",
          sortIndex: "2",
        },

        {
          gcLabel: "Batch",
          dataField: "BatchNo",
          gcType: "String",
          width: 180,
          cellTemplate: "batch-no-cell-template",
          allowFiltering: false,
          allowSorting: false,
        },

        {
          gcLabel: "Supplier",
          dataField: "SupplierCode",
          gcType: "String",
          width: 250,
          cellTemplate: "supplier-cell-template",
          allowFiltering: false,
          allowSorting: false,
        },

        {
          gcLabel: "Use By Date",
          dataField: "UseByDate",
          gcType: "Date",
          sortOrder: "asc",
          sortIndex: "2",
          allowSorting: false,
        },

        {
          gcLabel: "Count",
          dataField: "Count",
          gcType: "Decimal-6-2",
          allowFiltering: false,
          allowSorting: false,
          cellTemplate: "count-cell-template",
        },

        {
          gcLabel: "Count To Date",
          dataField: "CountToDate",
          gcType: "Decimal-6-2",
          allowFiltering: false,
          allowSorting: false,
          cellTemplate: "count-cell-template",
        },

        {
          gcLabel: "",
          gcType: "String",
          gcSubType: "IconButton",
          cellTemplate: "copy-cell-template",
          allowFiltering: false,
        },
      ]);
    },
    tabs() {
      return [
        {
          text: "Prepare",
          path: ``,
          applicationFeatureCode: "",
          disabled: true,
        },
        {
          text: "Count",
          path: `/stocktake-count/edit/${this.baseView.id}`,
          applicationFeatureCode: "StocktakeCount",
        },
        {
          text: "Review",
          path: ``,
          applicationFeatureCode: "",
          disabled: true,
        },
      ];
    },
  },
  methods: {
    keyDown(e) {
      this.$logger.debug(this.currentRowIndex, "this.currentRowIndex");
      if (e.event.code == "Tab" && this.currentRowIndex != null) {
        setTimeout(() => {
          this.validateSaveStocktakeCount(this.currentRowIndex);
        }, 200);
      }
    },
    focusedCellChanged(e) {
      this.currentRowIndex = e.rowIndex;
    },
    validateSaveStocktakeCount(rowIndex) {
      var data = this.dataSourceConfig.items()[rowIndex];
      this.$logger.debug("data ", data);
      if (!data.editable) {
        return;
      }
      if (data.IsBatchProduct != "No") {
        // #27532 : Auto Batch processing issue
        if (
          data.IsBatchProduct == "Auto" &&
          data.BatchNo &&
          data.SupplierCode &&
          (data.Count != 0 || data.ReferenceNo != "")
        ) {
          this.saveStocktakeCount(data, rowIndex);
        } else if (
          data.IsBatchProduct == "NextNo" &&
          data.SupplierCode &&
          (data.Count != 0 || data.ReferenceNo != "")
        ) {
          this.saveStocktakeCount(data, rowIndex);
        } else if (
          data.BatchNo &&
          data.SupplierCode &&
          (data.Count != 0 || data.ReferenceNo != "")
        ) {
          this.saveStocktakeCount(data, rowIndex);
        }
      } else {
        if (data.Count != 0 || data.ReferenceNo != "") {
          this.saveStocktakeCount(data, rowIndex);
        }
      }
    },
    async saveStocktakeCount(data, rowIndex) {
      this.showLoading(true);
      var payload = {
        ReferenceNo: data.ReferenceNo ? data.ReferenceNo : "",
        BatchNo: data.BatchNo,
        BinLocationCode: data.BinLocationCode,
        BranchCode: this.model.BranchCode,
        Count: data.Count,
        ProductCode: data.ProductCode,
        StocktakeCode: this.model.StocktakeCode,
        SupplierCode: data.SupplierCode,
        UseByDate: data.UseByDate,
      };

      await StocktakeCountService.saveStocktakeCount(payload)
        .then((result) => {
          this.$logger.debug("result ", result);
          if (result.data) {
            this.dataSourceConfig.items()[rowIndex].ReferenceNo =
              result.data.ReferenceNo;
            this.dataSourceConfig.items()[rowIndex].CountToDate =
              result.data.CountToDate;
            this.dataSourceConfig.items()[rowIndex].BatchNo =
              result.data.BatchNo;
            this.dataSourceConfig.items()[rowIndex].editable = false;
            this.dataSourceConfig.items()[rowIndex].batchSelected = true;

            this.dataSourceConfig.items().forEach((element) => {
              if (
                element.ProductCode == result.data.ProductCode &&
                element.BatchNo == result.data.BatchNo &&
                element.SupplierCode == result.data.SupplierCode &&
                !element.editable
              ) {
                element.CountToDate = result.data.CountToDate;
                if (element.CopyCode) {
                  this.updateCopyData(
                    element.CopyCode,
                    "CountToDate",
                    result.data.CountToDate
                  );
                }
              }
            });
            this.showLoading(false);
          }
        })
        .catch((error) => {
          this.$logger.debug("error ", error);
          this.showLoading(false);

          this.displayServerError(error, "Stocktake Count Commit Failed");
        });
    },
    getSupplierDataSource(ProductCode) {
      return StocktakeCountService.dataSourceConfig("api/ProductSupplierList", {
        select: ["SupplierCode,SupplierName,ProductCode"],
        sort: [{ selector: "SupplierCode", asc: true }],
        filter: ["ProductCode", "=", ProductCode],
      });
    },
    getBatchNoDataSource(ProductCode) {
      return StocktakeCountService.dataSourceConfig("api/StockBatch", {
        select: [
          "BatchNo,UseByDate,SupplierName,SupplierCode,BatchDateCreated",
        ],
        sort: [{ selector: "BatchDateCreated", desc: true }],
        filter: [
          ["StocktakeCode", "=", parseInt(this.baseView.id)],
          "and",
          ["BranchCode", "=", this.model.BranchCode],
          "and",
          ["ProductCode", "=", ProductCode],
          "and",
          ["BatchNo", "<>", ""],
        ],
        postProcess: (data) => {
          var items = [];
          data.forEach((element) => {
            if (element.BatchNo != "") {
              items.push(element);
            }
          });
          return items;
        },
      });
    },
    getBinLocationDataSource() {
      return StocktakeCountService.dataSourceConfig("api/StocktakeBin", {
        select: [
          "BinLocationCode,BinLocationLocation,BranchCode,StocktakeCode",
        ],
        filter: [
          ["StocktakeCode", "=", parseInt(this.baseView.id)],
          "and",
          ["BranchCode", "=", this.model.BranchCode],
        ],
      });
    },
    onAddClickHandler(data) {
      this.$logger.trackEventButtonClick(`Stocktake Count Add Line`);

      let dataObj = Object.assign(
        { copiedLine: true, index: data.rowIndex },
        data.data
      );
      dataObj.ReferenceNo = null;
      dataObj.Count = 0;
      dataObj.CountToDate = 0;
      dataObj.batchSelected = false;
      dataObj.editable = true;
      dataObj.BatchNo = "";
      dataObj.SupplierName = "";
      dataObj.SupplierCode = "";
      dataObj.UseByDate = null;
      dataObj.CopyCode =
        dataObj.ProductCode + "-" + Math.floor(Date.now() / 1000);

      copyItemsData.push(dataObj);

      ds.load();
    },
    onValueChange(valueChangedArgs, data, fieldName) {
      this.dataSourceConfig.items()[data.rowIndex][fieldName] =
        valueChangedArgs.value;

      if (data.data.CopyCode) {
        this.updateCopyData(
          data.data.CopyCode,
          fieldName,
          valueChangedArgs.value
        );
      }
    },
    stockTakeCountInitialized(e) {
      detailsGridInstance = e.component;
    },
    clickOnBatchNo(e, data) {
      this.dataSourceConfig.items()[data.rowIndex].batchSelected = true;
      this.dataSourceConfig.items()[data.rowIndex].SupplierCode =
        e.itemData.SupplierCode;
      this.dataSourceConfig.items()[data.rowIndex].SupplierName =
        e.itemData.SupplierName;
      this.dataSourceConfig.items()[data.rowIndex].UseByDate =
        e.itemData.UseByDate;

      if (
        data.data.IsBatchProduct != "Auto" &&
        data.data.IsBatchProduct != "NextNo"
      ) {
        data.value = e.itemData.BatchNo;
        data.data.BatchNo = e.itemData.BatchNo;
      } else {
        e.component.reset();
      }

      if (
        data.data.CopyCode &&
        data.data.IsBatchProduct != "Auto" &&
        data.data.IsBatchProduct != "NextNo"
      ) {
        this.updateCopyData(data.data.CopyCode, "BatchNo", e.itemData.BatchNo);
      }
    },
    onClickSupCode(e, data) {
      this.dataSourceConfig.items()[data.rowIndex].SupplierCode =
        e.itemData.SupplierCode;
      this.dataSourceConfig.items()[data.rowIndex].SupplierName =
        e.itemData.SupplierName;

      if (data.data.CopyCode) {
        this.updateCopyData(
          data.data.CopyCode,
          "SupplierCode",
          e.itemData.SupplierCode
        );
        this.updateCopyData(
          data.data.CopyCode,
          "SupplierName",
          e.itemData.SupplierName
        );
      }
    },
    onCustomItemCreating(e, data, fieldName) {
      if (
        data.data.IsBatchProduct == "Auto" ||
        data.data.IsBatchProduct == "NextNo"
      ) {
        e.component.reset();
        return;
      }
      if (!e.text) {
        e.customItem = null;
        this.dataSourceConfig.items()[data.rowIndex][fieldName] = null;
        this.dataSourceConfig.items()[data.rowIndex].batchSelected = false;
        return;
      }

      const newItem = {
        BatchNo: e.text,
      };
      data.data[fieldName] = e.text;
      e.customItem = newItem;
      data.data["batchSelected"] = "false";

      this.dataSourceConfig.items()[data.rowIndex][fieldName] = e.text;
      this.dataSourceConfig.items()[data.rowIndex].batchSelected = false;

      if (data.data.CopyCode) {
        this.updateCopyData(data.data.CopyCode, fieldName, e.text);
      }
    },
    updateCopyData(code, dataField, value) {
      copyItemsData.forEach((element) => {
        if ((element.CopyCode = code)) {
          element.dataField = value;
        }
      });
    },
    onToolbarPreparingPGCustomer(e) {
      e.toolbarOptions.items.unshift(
        {
          location: "before",
          widget: "dxSelectBox",
          options: {
            dataSource: BranchService.dataSourceConfig("api/StocktakeBranch", {
              sort: [{ selector: "BranchDescription", asc: true }],
              // select: ["Description", "Code"],
              filter: ["StocktakeCode", "=", parseInt(this.baseView.id)],
            }),
            valueExpr: "BranchCode",
            searchExpr: ["BranchCode", "BranchDescription"],
            searchMode: "contains",
            showClearButton: true,
            itemTemplate: "branchTemplate",
            searchEnabled: true,
            displayExpr: "BranchDescription",
            acceptCustomValue: false,
            value: this.model.BranchCode,
            onValueChanged: (e) => {
              this.model.BranchCode = globalBranchCode = e.value;
              this.currentRowIndex = null;
              this.applyToolBarFilter();
            },
            width: 200,
            placeholder: "Branch",
            onContentReady: (e) => {
              var data = e.component.getDataSource();
              var defaultBranch = data._items.filter((x) => {
                return x.IsDefault == "Y";
              });

              if (defaultBranch.length > 0 && !this.model.BranchCode) {
                e.component.beginUpdate();
                this.model.BranchCode = globalBranchCode =
                  defaultBranch[0].BranchCode;
                e.component.option("value", this.model.BranchCode);
                e.component.endUpdate();
              }
            },
            deferRendering: false,
          },
        },
        {
          location: "before",
          widget: "dxSelectBox",
          options: {
            dataSource: ProductCategory1Service.dataSourceConfig(
              "api/ProductCategory2",
              {
                select: ["Code", "Description"],
                filter: [["Inactive", "=", "N"]],
                sort: [{ selector: "Description", asc: true }],
              }
            ),
            itemTemplate: "ProductCategory2Template",
            valueExpr: "Code",
            displayExpr: "Description",
            searchExpr: ["Code", "Description"],
            searchMode: "contains",
            showClearButton: true,
            searchEnabled: true,
            onValueChanged: (e) => {
              this.ProductCategory2Code = e.value;
              this.applyToolBarFilter();
            },
            width: 200,
            placeholder: "Category 2",
          },
        }
      );
    },
    applyToolBarFilter() {
      if (this.model.BranchCode) {
        var filter = ["BranchCode", "=", this.model.BranchCode];
        if (this.ProductCategory2Code) {
          filter = [
            ["BranchCode", "=", this.model.BranchCode],
            "and",
            ["ProductCategory2Code", "=", this.ProductCategory2Code],
          ];
        }
        ds.filter([
          ["StocktakeCode", "=", parseInt(this.baseView.id)],
          "and",
          filter,
        ]);
        // ds.load();
        this.dataSourceConfig = ds;
      }
    },
    async Initialized() {
      await StocktakeCountService.getStockTakeListItemById(this.baseView.id)
        .then(async (result) => {
          if (result.data.value[0].Status == "A") {
            // ds.filter([
            //   ["StocktakeCode", "=", parseInt(this.baseView.id)],
            //   "and",
            //   ["BranchCode", "=", this.model.BranchCode],
            // ]);
            // await ds.load().then(()=> {
            //   this.dataSourceConfig = ds;
            // });
          } else {
            this.setIgnoreRouteChangeConfirmation();
            this.$router.push({
              name: "pageNotFound",
            });
          }
          this.loadingCompleted = true;
        })
        .catch((error) => {
          if (error) {
            this.setIgnoreRouteChangeConfirmation();
            this.$router.push({
              name: "pageNotFound",
            });
          }
        });
    },
    backButtonFunction() {
      // this.$logger.debug('data ', this.dataSourceConfig._items);
      if (this.dataSourceConfig._items) {
        this.$logger.debug("data 2", this.dataSourceConfig._items);
        var validate = this.dataSourceConfig.items().filter((item) => {
          return (
            item.IsBatchProduct !== "No" && item.editable && item.Count != 0
          );
        });

        if (validate.length == 0 || !this.model.BranchCode) {
          this.setIgnoreRouteChangeConfirmation();
        }
      } else {
        this.setIgnoreRouteChangeConfirmation();
      }
      this.$router.push({
        path: "/stocktake",
      });
    },
  },
  watch: {
    currentRowIndex(value, previusValue) {
      if (previusValue != null && previusValue > -1) {
        setTimeout(() => {
          this.validateSaveStocktakeCount(previusValue);
        }, 150);
      }
    },
  },
};
</script>

<style lang="scss">

</style>